import tinycolor from "tinycolor2";

export function getRoomColors(primaryColor: string | null | undefined): {
  roomBackgroundColor: string | undefined;
  roomTextColor: string | undefined;
} {
  if (primaryColor == null)
    return { roomBackgroundColor: undefined, roomTextColor: undefined };
  return {
    roomBackgroundColor: primaryColor,
    roomTextColor: tinycolor(primaryColor).isDark()
      ? "#fff"
      : "var(--color-primary-black)",
  };
}
